import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { InfoWindow } from '@react-google-maps/api';

import Map from '../google-map/Map';
import DeviceMarker from '../google-map/DeviceMarker';
import TemporaryStatusView from './TemporaryStatusView';
import { api_call, empty } from '../helpers/untils';

const DEFAULT_ZOOM = 15;

// Delivery links show the live car location on a Google map, with the trimmed
// status popup (name + Speed / Driven / Direction) anchored to the device marker.
const TemporaryDeliveryMap = (props) => {
  const { currentLink, loadLinkInfo, commands, isTest = false } = props;

  const history = useHistory();
  const device = useSelector((state) => state.devices.items[currentLink.deviceId]);

  const [googleMapKey, setGoogleMapKey] = useState('');
  const [map, setMap] = useState(null);
  const [popupOpen, setPopupOpen] = useState(true);

  const loadGoogleMapKey = async () => {
    const response = await api_call(`/api/get-env-info`);
    if (response.ok) {
      const apiResObj = await response.json();
      setGoogleMapKey(apiResObj['GOOGLE_MAP_KEY']);
    }
  };

  useEffect(() => {
    loadGoogleMapKey();
  }, []);

  if (empty(device) || !device.id) {
    return <></>;
  }

  const devicePosition = { lat: Number(device.latitude), lng: Number(device.longitude) };

  // marker shape expected by DeviceMarker (car icon comes from data.category, name is the label).
  const deviceMarker = {
    id: device.id,
    position: devicePosition,
    label: device.name,
    data: device,
  };

  return (
    <div style={{ width: '100vw', height: '100vh' }}>
      {googleMapKey && (
        <Map
          map={map}
          setMap={setMap}
          googleMapKey={googleMapKey}
          currentPosition={devicePosition}
          zoom={DEFAULT_ZOOM}
        >
          <DeviceMarker
            position={devicePosition}
            label={device.name}
            marker={deviceMarker}
            currentDeviceData={device}
            onClick={() => setPopupOpen(true)}
          />

          {popupOpen && (
            <InfoWindow
              position={devicePosition}
              onCloseClick={() => setPopupOpen(false)}
            >
              <TemporaryStatusView
                currentLink={currentLink}
                loadLinkInfo={loadLinkInfo}
                deviceId={currentLink.deviceId}
                address={``}
                lat={device.latitude}
                lng={device.longitude}
                onShowHistory={(deviceId) => history.push(`/temporary-replay/${deviceId}`)}
                history={history}
                commandsData={commands}
                userDeviceItem={device}
                isTest={isTest}
              />
            </InfoWindow>
          )}
        </Map>
      )}
    </div>
  );
};

export default TemporaryDeliveryMap;
